import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalDelete extends Component{
	constructor(props){
		super(props);
		
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onDelete = this.onDelete.bind(this);

		this.state = {
			show:false,
			eliminar:false,
			mantener:false,
			id:"",
			option:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.setState({
			show:true,
			id:id
		});
	}

	handleClose(){
		this.setState({
			show:false
		});
	}

	handleChange(e){
		if(e.target.name === "mantener"){
			this.setState({
				mantener: e.target.checked ? true : false,
				eliminar:false,
				option:"HOLD"
			});
		}else{
			this.setState({
				eliminar: e.target.checked ? true : false,
				mantener:false,
				option:"DELETE"
			});
		}
			
	}

	onDelete(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'pools_process/'+this.state.id+'?reserve_option='+this.state.option, {
  			method : 'delete',
  			headers: new Headers({
  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
  				'Accept'		: 'application/json',
  				'Content-Type'	: 'application/json'
  			})
  		}).then(res => {
  			this.props.waiting.handleClose();
  			if(res.ok){
  				return res.json();
  			}else{
  				res.text().then((msg)=>{
  					swal('Error', msg, 'error');
  				})
  			}
  		})
  		.then(response=>{
  			if(response !== undefined){
  				this.props.getList();
  				swal('Success', 'El registro se elimino correctamente', 'success');
  				this.handleClose();
  			}
  		})
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Unidad Reservada</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
	        				<h5>Seleccione la acción que desea realizar?</h5>
	        				<div className="col-xs-12">
	        					<input type="checkbox" name="mantener" id="mantener" value={this.state.mantener} 
	        						checked={this.state.mantener} onChange={this.handleChange} />
	        					<span style={{marginLeft:'8px'}}>Mantener</span>
	        				</div>
	        				<div className="col-xs-12">
	        					<input type="checkbox" name="eliminar" id="eliminar" value={this.state.eliminar} 
	        						checked={this.state.eliminar} onChange={this.handleChange} />
	        					<span style={{marginLeft:'8px'}}>Eliminar</span>
	        				</div>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.submit')}  onClick={this.onDelete}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}

}
export default translate('translations')(ModalDelete)